import gql from "graphql-tag";

export default {

    get: gql`
    query PhotoboothCell($id: ID!) {
        photoboothCell(id: $id) {
            id
            with_email
        }
    }`,

    update: gql`
        mutation updatePhotoboothCell($input: UpdatePhotoboothCellInput!) {
            updatePhotoboothCell(input: $input) {
                id
                with_email
        }
    }`
};
